<template>
  <div class="panel panel-default endpoint">
    <div class="panel-heading" @click="toggle()">
      <div class="row">
        <div class="col-sm-12">
          <h4 class="panel-title title">
            <span
              class="label label-success label-method"
              :class="{ 'is-command': isCommand, 'is-query': isQuery }"
              >{{ method }}</span
            >
            <code>{{ endpoint.path }}</code>
          </h4>
        </div>
      </div>
    </div>
    <div class="panel-collapse collapse" :class="{ in: isOpen }">
      <div class="panel-body">
        <input v-model="url" class="form-control input-sm" />
        <button class="btn btn-primary" @click="performRequest()">
          Perform request
        </button>

        <div
          v-show="gotResponse"
          class="response-body"
          :class="{ 'loader-cover': requestInProgress }"
        >
          <h3>HTTP {{ response.status }}</h3>

          <h4>Headers</h4>
          <dl class="dl-horizontal">
            <template v-for="(header, idx) in getHeaders(response.headers)">
              <dt :key="`${header.name}_${idx}`">{{ header.name }}</dt>
              <dd :key="`${header.value}_${idx}`">
                <code>{{ header.value }}</code>
              </dd>
            </template>
          </dl>

          <h4>Body</h4>
          <pre v-if="responseIsJson">{{ response.data | json }}</pre>
          <pre v-if="!responseIsJson">{{ response.data }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import http from 'services/http'

export default {
  props: {
    endpoint: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isOpen: false,
      requestInProgress: false,
      gotResponse: false,
      response: {},
      url: '',
    }
  },
  computed: {
    method() {
      const methods = new Set(this.endpoint.methods)
      if (methods.has('GET')) {
        return 'GET'
      } else if (methods.has('POST')) {
        return 'POST'
      }
      return 'GET'
    },
    isCommand() {
      return this.method === 'POST'
    },
    isQuery() {
      return this.method === 'GET'
    },
    responseIsJson() {
      if (!this.response.headers) {
        return false
      }
      return this.response.headers['content-type'] === 'application/json'
    },
  },
  created() {
    this.url = this.endpoint.path.replace(/<(\w+)>/, (match, argName) =>
      argName.toUpperCase(),
    )
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    async performRequest() {
      this.requestInProgress = true
      const methodName = `${this.method.toLowerCase()}Authed`
      const httpMethod = http[methodName]
      try {
        var response = await httpMethod(this.url)
      } catch (error) {
        var response = error.response
      }
      this.response = response
      this.gotResponse = true
      console.log(' response:', response)
      this.requestInProgress = false
    },
    getHeaders(headers) {
      return _.entries(headers).map((pair) => {
        return { name: pair[0], value: pair[1] }
      })
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.api-docs {
  margin-top: 30px;

  .endpoint {
    min-height: 20px;
    margin-bottom: 10px;

    .panel-heading {
      &:hover {
        cursor: pointer;
      }
    }

    .form-control {
      margin-bottom: 10px;
    }

    code {
      color: $grey90;
    }

    pre {
      background-color: #fff;
    }

    .label-method {
      border-radius: 4px;
      padding: 5px;
      display: inline-block;
      width: 60px;
      margin-right: 10px;

      &.is-command {
        background-color: $blue;
      }
    }
  }
}
</style>
